import { colors } from '@ardoq/design-tokens';
import { GetCssClassNamesOption } from '@ardoq/data-model';

export const FLEX_GAP = 8;
export const REFERENCE_BORDER_RADIUS = 15;
export const URL_FIELD_VALUES_ATTR = 'data-url-field-values';
export const VIEW_NODE_ID_ATTR = 'data-view-node-id';
export const GLOBAL_HANDLER_ID_ATTRIBUTE = 'data-global-handler-id';
export const COLLAPSED_REFERENCE_BOX_SHADOW_WIDTH = 3;
export const COLLAPSED_REFERENCE_BOX_SHADOW = `1px 1px ${colors.white950}, 2px 2px currentColor, ${COLLAPSED_REFERENCE_BOX_SHADOW_WIDTH}px ${COLLAPSED_REFERENCE_BOX_SHADOW_WIDTH}px 1px ${colors.borderAction}`;

export const CHANGE_DEPTH = 'Change depth';

export const NODE_LIMIT = 10000;
export const INFINITE_DEGREES = -1;

export const GET_CSS_BACKGROUND_OPTIONS: GetCssClassNamesOption = Object.freeze(
  {
    includeLevels: false,
    useAsBackgroundStyle: true,
  }
);

export const GLOBAL_PARENT_CHILD_COLOR = colors.black950;
